(()=>{
  const current=document.currentScript;
  const applyUpdates=()=>{
    const root=document.getElementById('kidatag-premium');
    if(!root) return;

    /* 31/08 — 3 modifications demandées : titre, fermeture, autonomie. */
    const heroAccent=root.querySelector('.kt-hero h1 span');
    if(heroAccent) heroAccent.textContent='Le 1er bracelet enfant localisable.';

    const closureImg=root.querySelector('.kt-closure-focus img');
    if(closureImg){
      closureImg.src='https://cdn.shopify.com/s/files/1/1027/9619/8217/files/kidatag-zoom-fermeture-validee.jpg?v=1788203691';
      closureImg.removeAttribute('srcset');
      closureImg.alt='Gros plan sur le système de fermeture réel du bracelet KidaTag';
      closureImg.width=1086;
      closureImg.height=1448;
    }

    const moduleDemo=root.querySelector('.kt-module-demo');
    if(moduleDemo){
      moduleDemo.classList.add('kt-module-demo-photo');
      moduleDemo.setAttribute('aria-label','KidaTag avec AirTag dans sa cavité arrière et rondelle silicone amovible');
      moduleDemo.innerHTML='<img src="https://cdn.shopify.com/s/files/1/1027/9619/8217/files/kidatag-airtag-sans-recharge.jpg?v=1788203700" alt="KidaTag avec AirTag dans sa cavité arrière et rondelle silicone amovible" width="1536" height="1024" loading="lazy">';
    }

    const style=document.createElement('style');
    style.id='kt-user-updates-2114';
    style.textContent=`
      #kidatag-premium .kt-hero h1 span{display:inline-block;line-height:.98}

      /* Utiliser exactement la photo de fermeture fournie, sans zoom artificiel ni déformation. */
      #kidatag-premium .kt-closure-focus{height:auto!important;aspect-ratio:1086/1448!important;max-width:560px!important;margin:38px auto 0!important;border-radius:30px!important;overflow:hidden!important;background:#f4eadc!important;box-shadow:0 22px 58px rgba(47,54,48,.11)!important}
      #kidatag-premium .kt-closure-focus:after{content:none!important;display:none!important}
      #kidatag-premium .kt-closure-focus img{position:static!important;display:block!important;width:100%!important;height:100%!important;max-width:100%!important;left:auto!important;top:auto!important;object-fit:cover!important;object-position:center!important;transform:none!important;filter:none!important}

      /* Remplacer le faux schéma du module par l'infographie fournie. */
      #kidatag-premium .kt-battery{grid-template-columns:1.15fr .85fr!important;align-items:center!important;gap:42px!important}
      #kidatag-premium .kt-module-demo.kt-module-demo-photo{display:block!important;min-height:0!important;height:auto!important;aspect-ratio:3/2!important;padding:0!important;border-radius:28px!important;overflow:hidden!important;background:#f7efe4!important;border:1px solid rgba(255,255,255,.14)!important}
      #kidatag-premium .kt-module-demo.kt-module-demo-photo img{display:block!important;width:100%!important;height:100%!important;object-fit:contain!important;object-position:center!important;transform:none!important}

      @media(max-width:1050px){
        #kidatag-premium .kt-battery{grid-template-columns:1fr!important;max-width:820px!important}
        #kidatag-premium .kt-module-demo.kt-module-demo-photo{width:100%!important;max-width:760px!important;margin:0 auto!important}
      }
      @media(max-width:680px){
        #kidatag-premium .kt-hero h1 span{font-size:.82em}
        #kidatag-premium .kt-closure-focus{width:min(100%,440px)!important;max-width:440px!important;height:auto!important;aspect-ratio:1086/1448!important;margin-top:28px!important;border-radius:24px!important}
        #kidatag-premium .kt-battery{gap:30px!important}
        #kidatag-premium .kt-module-demo.kt-module-demo-photo{width:100%!important;max-width:100%!important;aspect-ratio:3/2!important;border-radius:22px!important}
      }
    `;
    document.head.appendChild(style);
  };

  let baseSrc='';
  if(current && current.src){
    baseSrc=current.src.replace(/kidatag-premium\.js(?:\?[^#]*)?$/,'kidatag-premium-base-3108.js');
  }
  if(baseSrc && baseSrc!==current.src){
    const base=document.createElement('script');
    base.src=baseSrc;
    base.onload=applyUpdates;
    base.onerror=applyUpdates;
    document.head.appendChild(base);
  }else{
    applyUpdates();
  }
})();
